import { AbstractControl, UntypedFormGroup, ValidatorFn } from '@angular/forms';

export function conditionalRequiredValidator(form: UntypedFormGroup, checkFor2: boolean): ValidatorFn {
  return (control: AbstractControl): Record<string, any> | null => {
    const formValues = Object.entries(form.value);
    const filteredValues = checkFor2
      ? formValues.filter(([key]) => key.endsWith('2'))
      : formValues.filter(([key]) => !key.endsWith('2'));
    const allValuesAreNull: boolean = filteredValues.every(([, val]) => val === null || val === '');
    const allValuesAreEmpty: boolean = filteredValues.every(
      ([, val]) => val === null || val === '' || val === undefined,
    );
    if (allValuesAreNull || allValuesAreEmpty) {
      return null;
    } else {
      return control.value === null || control.value === '' || control.value === undefined
        ? { required: true }
        : null;
    }
  };
}

export function changeAllFormValuesNullIfEmptyString(form: UntypedFormGroup): void {
  Object.keys(form.value).forEach((key: string): void => {
    if (form.value[key] === '') {
      form.get(key).setValue(null, { emitEvent: false });
    }
  });
}

export function clearAllErrorsIfAllValuesAreNull(form: UntypedFormGroup): void {
  const allValuesAreNull: boolean = Object.values(form.value).every(
    (val) => val === null || val === '',
  );
  if (allValuesAreNull) {
    Object.keys(form.controls).forEach((key: string): void => {
      form.get(key).setErrors(null);
    });
  }
}
